export default __webpack_public_path__ + "locales/ro/FilesSettings.json?hash=2c6647dbb9b5fd75836b68dd70bba68a";